<template>
    <div class="main">
        <div class="TC-container">
            <div class="terms-and-conditions">
                <SimplePageBuilder :response="response"></SimplePageBuilder>
            </div>
        </div>
    </div>
</template>
<script>
import { SimplePageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'TermsAndConditions',
    components: {
        SimplePageBuilder,
    },
    data() {
        return {
            response: [],
        };
    },
    mounted() {
        //  mountKareScript(document);
        this.setTermsAndConditions();
    },
    //    beforeDestroy() {
    //        removeKare(document);
    //    },
    methods: {
        async setTermsAndConditions() {
            const TandC = await require(`@/content/${process.env.VUE_APP_COUNTRY_ISO}/${process.env.VUE_APP_I18N_LOCALE}/TermsAndConditions`);
            this.termsAndConditions = TandC.items;
            // import('@/content/AUT/de/TermsAndConditions').then(module => module.default).then(response => {
            //     this.termsAndConditions = response.items;
            // });
        },
    },
    created() {
        getButterCmsPage('terms-and-conditions').then((res) => this.response = res);
    },
};
</script>

<style lang="scss">
.terms-and-conditions {
    text-align: left;
    width: 100%;
    margin: 0 auto;
    margin-top: 2.5rem;
    ul li p {
        margin: 10px auto;
    }
    .heading--medium {
            font-size: 30px;
            line-height: 35px;
            margin-top: 15px;
            text-align: center;
        }
}
.TC-container {
    max-width: 850px;
    width: 70%;
    margin: 0 auto;
    padding-bottom: 2.5rem;
}
</style>
